import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { CommerceOrderStatus } from "@teqtank/commerce-sdk";
@customElement("teqtank-order-status")
export class TeqtankOrderStatus extends LitElement {
    @property() public accessor status: CommerceOrderStatus = "pending";
    public static override styles = css`
        :host {
            container-type: inline-size;
            display: block;
        }
        .status {
            display: flex;
            gap: 0.8rem;
            align-items: center;
        }
        .mark {
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 999px;
            display: grid;
            place-items: center;
            background: #eef8f1;
            color: #23633a;
            font-weight: 800;
        }
        .pending,
        .processing {
            background: #f7f4ee;
            color: #8d5c3f;
        }
        .failed,
        .cancelled {
            background: #fff2ef;
            color: #9b2e1f;
        }
        h2,
        p {
            margin: 0;
        }
        p {
            color: var(--teqtank-color-text-muted, #69736d);
            font-size: 0.9rem;
            margin-top: 0.2rem;
        }
    `;
    protected override render() {
        const text =
            this.status === "completed"
                ? [
                      "Order confirmed",
                      "Your payment is complete and your order is ready for fulfilment.",
                  ]
                : this.status === "failed"
                  ? [
                        "Order finalisation failed",
                        "Your order needs attention before it can continue.",
                    ]
                  : this.status === "cancelled"
                    ? ["Order cancelled", "This order is no longer being processed."]
                    : [
                          "Finalising your order",
                          "Payment is approved. We are preparing your receipt and fulfilment details.",
                      ];
        return html`<div class="status">
            <div class="mark ${this.status}">
                ${this.status === "completed" ? "✓" : this.status === "failed" ? "!" : "…"}
            </div>
            <div>
                <h2>${text[0]}</h2>
                <p>${text[1]}</p>
            </div>
        </div>`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "teqtank-order-status": TeqtankOrderStatus;
    }
}
